import { render, staticRenderFns } from "./studentArchivesList.vue?vue&type=template&id=3e851d00&scoped=true"
import script from "./studentArchivesList.vue?vue&type=script&lang=js"
export * from "./studentArchivesList.vue?vue&type=script&lang=js"
import style0 from "./studentArchivesList.vue?vue&type=style&index=0&id=3e851d00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e851d00",
  null
  
)

export default component.exports